let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lbtNt")).then(() => parcelRequire('3v762'));